import { api } from '../../lib/api';
import type {
  BusinessProfile,
  BusinessProfileInput,
  PromotionInput,
  PromotionRow,
} from '../../types/businessProfile';

// The STAFF host's endpoints (surface 'kyck'). The editors take these as props, so the client
// portal host can pass its own, behind its own guard, later.

export interface ProfileBundle {
  accountName: string | null;
  profile: BusinessProfile | null;
  promotions: PromotionRow[];
  timezone: string;
}

export const getProfileBundle = (accountId: string): Promise<ProfileBundle> =>
  api<ProfileBundle>(`/api/business-profile/${encodeURIComponent(accountId)}`);

export const saveProfile = (accountId: string, input: BusinessProfileInput): Promise<BusinessProfile> =>
  api<BusinessProfile>(`/api/business-profile/${encodeURIComponent(accountId)}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });

export const createPromotionApi = (accountId: string, input: PromotionInput): Promise<PromotionRow> =>
  api<PromotionRow>(`/api/business-profile/${encodeURIComponent(accountId)}/promotions`, {
    method: 'POST',
    body: JSON.stringify(input),
  });

export const updatePromotionApi = (accountId: string, id: string, input: PromotionInput): Promise<PromotionRow> =>
  api<PromotionRow>(
    `/api/business-profile/${encodeURIComponent(accountId)}/promotions/${encodeURIComponent(id)}`,
    { method: 'PUT', body: JSON.stringify(input) },
  );

export const deletePromotionApi = (accountId: string, id: string): Promise<unknown> =>
  api(`/api/business-profile/${encodeURIComponent(accountId)}/promotions/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
